<template>
    <div>
        <page-header title="Sager">
            <router-link :to="{ name: 'projects.new' }" class="button is-primary">Opret</router-link>
        </page-header>
        <div class="tabs">
            <ul>
                <li :class="{ 'is-active': tab === 'open' }">
                    <a @click="setActiveTab('open')">
                        Åbne &nbsp;<span class="tag">{{ count.open }}</span>
                    </a>
                </li>
                <li :class="{ 'is-active': tab === 'closed' }">
                    <a @click="setActiveTab('closed')">
                        Lukkede &nbsp;<span class="tag">{{ count.closed }}</span>
                    </a>
                </li>
                <li :class="{ 'is-active': tab === 'invoiced' }">
                    <a @click="setActiveTab('invoiced')">
                        Fakturerede &nbsp;<span class="tag">{{ count.invoiced }}</span>
                    </a>
                </li>
            </ul>
        </div>
        <div class="field">
            <input v-model="query" class="input"
                    placeholder="Søg efter sager... "
                    type="search" @input="search()">
        </div>
        <!-- <div class="field">
            <InputSelectSearch
                :options="contacts"
                v-model="contact"
                label="name"
                placeholder="Vælg kontakt..."
                @input="onContactChange"
            />
        </div> -->
        <div class="field is-flex users-change">
            <b-switch
                :rounded="false"
                @input="onAllUsersChange"
                v-model="allUsers"
                class="users-change__toggle"
            >
                Alle brugere
            </b-switch>
            <InputSelectSearch
                customClass="flex-grow"
                :options="users"
                v-model="selectedUsers"
                label="name"
                :multiple="true"
                placeholder="Vælg brugere..."
                @input="onUserSelected"
            />
        </div>
        <table class="table is-fullwidth table-fixed">
            <thead>
                <tr>
                    <th @click="onUpdateOrderBy('projects.id')" class="w-id is-clickable" width="125px">Sagsnr.
                        <SortArrow :orderBy="orderBy" field="projects.id" :direction="direction"/>
                    </th>
                    <th @click="onUpdateOrderBy('projects.created_at')" class="w-date is-clickable" width="120px">Dato
                        <SortArrow :orderBy="orderBy" field="projects.created_at" :direction="direction"/>
                    </th>
                    <th @click="onUpdateOrderBy('customers.name')" class="w-customer is-clickable" width="230px">Kunde
                        <SortArrow :orderBy="orderBy" field="customers.name" :direction="direction"/>
                    </th>
                    <th @click="onUpdateOrderBy('customer_locations.name')" class="w-location is-clickable" width="170px">Lokation
                        <SortArrow :orderBy="orderBy" field="customer_locations.name" :direction="direction"/>
                    </th>
                    <th @click="onUpdateOrderBy('users.initials')" class="w-initials is-clickable" width="70px">ID
                        <SortArrow :orderBy="orderBy" field="users.initials" style="margin-right: 0px" :direction="direction"/>
                    </th>
                    <th @click="onUpdateOrderBy('projects.description')" class="is-clickable">Beskrivelse
                        <SortArrow :orderBy="orderBy" field="projects.description" :direction="direction"/>
                    </th>
                </tr>
            </thead>
            <tbody v-if="!isFetching">
                <template v-for="(project, index) in projects">
                    <tr
                        :class="{
                            'is-danger': project.is_overdue,
                            'remove-bottom-border': collapsed[project.id] || false,
                        }"
                        :key="project.id"
                    >
                        <td @click="openProject(project)">
                            <i
                                class="fa fa-w16 is-clickable"
                                :class="{
                                    'fa-chevron-down': collapsed[project.id] || false,
                                    'fa-chevron-right': !collapsed[project.id] || false,
                                }"
                                @click.stop="toggleCollapse(project)"
                            />
                            #{{ project.id }}
                        </td>
                        <td class="is-clickable" @click="openProject(project)">{{ project.created_at | humanDate }}</td>
                        <td class="is-clickable overflow-dots" @click="openProject(project)">{{ project.customer.name }}</td>
                        <td class="is-clickable overflow-dots" @click="openProject(project)">{{ projectLocation(project) }}</td>
                        <td class="is-clickable" @click="openProject(project)">{{ project.user.initials }}</td>
                        <td
                            :class="[
                                'is-clickable overflow-dots is-relative',
                                project.is_credit_note || project.missing_return_item ? 'pr-3_5rem' : ''
                            ]"
                            @click="openProject(project)"
                        >
                            {{ project.description }}
                            <i
                                v-if="project.missing_return_item"
                                :class="[
                                    'list-icon-position fa fa-exchange-alt fa-w16',
                                    project.is_overdue ? 'is-white' : 'is-danger',
                                    project.is_credit_note ? 'mr-5' : '',
                                ]"
                                @click.stop="toggleCollapse(project)"
                                title="Mangler returvare"
                            />
                            <i
                                v-if="project.invoice_ean"
                                :class="[
                                    'list-icon-position fa fa-file-invoice-dollar fa-w16 is-danger',
                                    project.is_credit_note ? 'mr-5' : '',
                                ]"
                                @click.stop="toggleCollapse(project)"
                                title="EAN-faktura"
                            />
                            <i
                                v-if="project.is_credit_note"
                                :class="[
                                    'list-icon-position fa fa-dollar-sign fa-w16 text-center',
                                    project.is_overdue ? 'is-white' : 'is-danger'
                                ]"
                                @click.stop="toggleCollapse(project)"
                                title="Kreditnota"
                            />
                        </td>
                    </tr>
                    <tr v-if="collapsed[project.id] && project.reports !== undefined" :key="index">
                        <td colspan="5">
                            <div
                                v-for="report in project.reports"
                                :key="'report-'+report.id"
                                :class="['report', 'report--' + (report.closed_at !== null ? 'closed' : 'open') ]"
                                @click.stop="$router.push({ name: 'project.reports.edit', params: {
                                    id: report.project_id,
                                    reportid: report.id
                                }})"
                            >
                                {{ project.id }}-{{ report.id }} Servicerapport ({{ findUser(report.user_id) ? findUser(report.user_id).name : '' }})
                            </div>

                            <div class="report" @click.stop="createServiceRapport(project.id)" v-if="project.status === 0">
                                <span class="is-size-7" style="padding-left:10px">Opret servicerapport</span>
                            </div>
                        </td>
                    </tr>
                </template>
            </tbody>
            <tbody v-else>
                <tr v-for="index in skeletonRows" :key="index">
                    <td class="w-id">
                        <b-skeleton :animated="true"></b-skeleton>
                    </td>
                    <td class="w-date">
                        <b-skeleton :animated="true"></b-skeleton>
                    </td>
                    <td class="w-customer">
                        <b-skeleton :animated="true"></b-skeleton>
                    </td>
                    <td class="w-location">
                        <b-skeleton :animated="true"></b-skeleton>
                    </td>
                    <td class="w-initials">
                        <b-skeleton :animated="true"></b-skeleton>
                    </td>
                    <td>
                        <b-skeleton :animated="true"></b-skeleton>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="mt-2" v-if="!isFetching">
            <b-pagination
                v-model="currentPage"
                :per-page="pagination.per_page"
                :total="pagination.total"
                @change="paginate"
                order="is-right">
            </b-pagination>
        </div>
    </div>
</template>

<script>
import PageHeader from '@elems/pageHeader'
import humanDate from "../../filters/humanDate";
import SortArrow from '@elems/SortArrow'
import debounce from 'lodash/debounce'
import InputSelectSearch from "@elems/form/InputSelectSearch";

export default {
    components: {
        PageHeader,
        SortArrow,
        InputSelectSearch
    },
    filters: {
        humanDate,
    },

    data() {
        return {
            tab: 'open',
            count: {
                open: 0,
                closed: 0,
                invoiced: 0,
            },
            currentPage: 1,
            query: '',
            projects: [],
            contacts: [],
            users: [],
            selectedUsers: [],
            pagination: { total: 0 },
            isFetching: false,
            skeletonRows: 50,
            orderBy: null,
            direction: null,
            collapsed: {},
            contact: null,
            contact_id: null,
            allUsers: false,
            searchId: 0,
        }
    },
    mounted() {
        window.onpopstate = () => { this.reset(); };
    },
    beforeDestroy() {
        window.onpopstate = () => {};
    },
    computed: {
        isCollapsed(item) {
            return !!this.collapsed[item.id]
        },
        selectedUserIds() {
            return this.selectedUsers.map((user) => user.id);
        }
    },
    created() {
        this.reset();
    },
    methods: {
        async reset() {
            let params = new URLSearchParams(window.location.search)
            this.query = params.get('q');
            this.orderBy = params.get('order-by');
            this.direction = params.get('direction');
            this.tab = params.get('tab') || 'open';
            const contact = params.get('contact');
            this.contact_id = contact && /^[1-9]\d*$/.test(contact) ? parseInt(contact) : null;
            const page = params.get('page');
            this.currentPage = page && /^[1-9]\d*$/.test(page) ? parseInt(page) : 1;
            this.allUsers = (params.get('all-users') === 'true' ? true : false)

            if (!params.get('all-users')) {
                await this.fetchAllUsers();
            }

            await this.fetchUsers();
            this.fetchProjects(false);
            this.fetchContacts();
        },
        projectLocation(project) {
            if (project.location) {
                return project.location.name;
            }

            return project.ext_customer_name ? project.ext_customer_name : 'Ekstern lokation';
        },
        toggleCollapse(project) {
            project.collapsed = true;
        },
        toggleDirection() {
            this.direction = (this.direction === 'asc') ? 'desc' : 'asc';
        },
        onUpdateOrderBy(key) {
            this.toggleDirection();
            this.orderBy = key;
            this.fetchProjects();
        },
        search: debounce(function () {
            this.currentPage = 1;
            this.fetchProjects();
        }, 200),
        paginate(value) {
            this.currentPage = value;
            this.fetchProjects();
            window.scrollTo(0, 0);
        },
        fetchProjects(pushUrl = true) {
            const searchId = ++this.searchId;
            this.isFetching = true
            let params = {};

            if (this.query) params['q'] = this.query;
            if (this.currentPage > 1) params['page'] = this.currentPage;
            if (this.orderBy) params['order-by'] = this.orderBy;
            if (this.direction) params['direction'] = this.direction;
            if (this.tab != 'open') params['tab'] = this.tab;
            if (this.contact_id) params['contact'] = this.contact_id;
            if (this.selectedUsers.length > 0) params['users'] = this.selectedUsers.map((user) => user.id).join(',');

            params['all-users'] = this.allUsers;

            if (pushUrl) {
                this.$router.push({ path: '/projects', query: params })
            } else {
                this.$router.replace({ path: '/projects', query: params }).catch(err => {})
            }

            window.axios.get('/api/projects', { params })
                .then(({ data }) => {
                    if (searchId === this.searchId) {
                        this.projects = data.data
                        this.projects.forEach((project,index)=>{
                            if(project.status == "2"){
                                this.projects[index].customer.name = project.invoiced_data.customer.name;
                                if(this.projects[index].location){
                                    this.projects[index].location.name = project.invoiced_data.location.name;
                                }
                            }
                        });
                        this.pagination = data.meta
                        this.count = data.count
                        this.isFetching = false
                    }
                })
                .catch(error => {
                    console.error(error)
                    this.isFetching = true
                });
        },
        openProject(project) {
            this.$router.push({ name: 'project.edit', params: { id: project.id }})
        },
        setActiveTab(state) {
            this.currentPage = 1;
            this.tab = state;
            this.fetchProjects();
        },
        toggleCollapse(project) {
            this.$set(this.collapsed, project.id, !this.collapsed[project.id])
        },
        onAllUsersChange() {
            this.fetchProjects();
        },
        createServiceRapport(projectId) {
            window.axios.post('/api/reports', { project_id: projectId })
                .then(({ data }) => {
                    this.$store.dispatch('addReport', data)
                    this.$router.push({ name: 'project.reports.edit', params: {
                        id: projectId,
                        reportid: data.id
                    }})
                    this.$store.dispatch('setSuccess', 'Servicerapporten blev oprettet')
                })
                .catch(error => {})
        },
        findUser(userId) {
            return this.$store.getters.findUser(userId)
        },
        fetchContacts() {
            window.axios.get('/api/customers/contacts/options')
                .then(({ data }) => {
                    this.contacts = data;

                    if (this.contact_id) {
                        this.contact = this.contacts.filter(contact => contact.id === this.contact_id);
                    }
                })
                .catch(error => {
                    console.error(error)
                });
        },
        async fetchAllUsers() {
            await window.axios.get('/api/settings/users/' + this.$store.getters.user.id)
                .then(({ data }) => {
                    this.allUsers = data.filter_all_users;
                })
                .catch(error => {
                    console.error(error)
                });
        },
        async fetchUsers() {
            await window.axios.get('/api/users/options')
                .then(({ data }) => {
                    this.users = [];
                    this.selectedUsers = [];

                    data.forEach((user) => this.users.push({
                        id: user.id,
                        name: `${user.initials} - ${user.name}`,
                        selected: user.selected,
                    }))

                    const params = new URLSearchParams(window.location.search)
                    let paramUsers = params.get('users');

                    if (paramUsers) {
                        paramUsers = paramUsers.split(',').map((user) => parseInt(user))
                        this.selectedUsers = this.users.filter((user) => paramUsers.includes(user.id));
                    } else {
                        this.users.forEach((user) => {
                            if (user.selected) {
                                this.selectedUsers.push(user);
                            }
                        });
                    }
                })
                .catch(error => {
                    console.error(error)
                });
        },
        onContactChange(contact) {
            this.contact_id = contact ? contact.id : null;
            this.fetchProjects();
        },
        onUserSelected() {
            this.fetchProjects();
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~#/globals';

.pointer {
    cursor: pointer;
}

.fa-w16 {
    width: 16px;
}

.remove-bottom-border td {
    border-bottom: none;
}

.list-icon-position {
    position: absolute;
    top: 0.75rem;
    right: 0.5rem;
}

.users-change {
    flex-direction: column-reverse;

    @media (min-width: 768px) {
        flex-direction: row;
    }

    &__toggle {
        margin-top: 5px;

        @media (min-width: 768px) {
            margin-top: 0;
        }
    }
}
</style>
